import React, {useLayoutEffect, useState} from 'react';
import {
    Button,
    CardBody, Dialog, DialogBody, DialogFooter, DialogHeader,
    Input,
    Typography
} from "@material-tailwind/react";
import MapComponent from "../../shared/map_component";
import InputMask from "react-input-mask";
import axios from "axios";

const CodeCorrection = ({lot, movement}) => {
    const [error, setError] = useState(null);
    const [loaderActive, setLoaderActive] = useState(false);
    const [openEndDialog, setOpenEndDialog] = useState(false);
    const [currentLot, setCurrentLot] = useState([]);
    const [step, setStep] = useState(1);
    const [notes, setNotes] = useState('');
    const [newParcelCode, setNewParcelCode] = useState('');
    const [parcelCodeData, setParcelCodeData] = useState({
        location_type_id: '',
        sector_id: '',
        sector_name: '',
        block_id: '',
        block_name: '',
        batch: '',
    });

    useLayoutEffect(() => {
        setNotes(lot.notes);
    }, [lot]);

    const getCSRFToken = () => {
        const token = document.querySelector('meta[name="csrf-token"]');
        return token ? token.content : "";
    };

    const handleReset = () => {
        window.location.replace('movements');
    };

    const handleValidateParcelCode = async () => {
        setLoaderActive(true);

        if (newParcelCode === lot.parcel_code) {
            setError("La nueva clave no puede ser igual a la del predio seleccionado.")
            setLoaderActive(false);
            return
        }

        await axios.post(`lots/validate_parcel_code.json`, {
            parcel_code: newParcelCode,
        }, {
            headers: {
                'Content-Type': 'application/json',
                "X-CSRF-Token": getCSRFToken(),
            }
        })
            .then(response => {
                const data = response.data;

                if (data.available) {
                    setParcelCodeData({
                        location_type_id: data.location_type_id,
                        sector_id: data.sector_id,
                        sector_name: data.sector_name,
                        block_id: data.block_id,
                        block_name: data.block_name,
                        batch: data.batch,
                    });
                    setError(null);
                    setStep(2);
                } else {
                    setError(`La clave catastral ya se encuentra en uso, clave sugerida: ${data.suggested}`);
                }
                setLoaderActive(false);
            })
            .catch(error => {
                setError('Error al verificar la clave catastral.');
                setLoaderActive(false);
            });
    }

    const handleSubmit = async () => {
        setLoaderActive(true);

        try {
            const response = await axios.post(`lots/${lot.parcel_code}/code_correction.json`, {
                new_parcel_code: newParcelCode,
                lot: {
                    last_parcel_code: lot.parcel_code.substring(3, 14),
                    notes: notes,
                    reason_type_id: movement.id
                }
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "X-CSRF-Token": getCSRFToken(),
                }
            });
            if (response.status === 200) {
                setOpenEndDialog(true);
                const current_lot_url = `/lots/${newParcelCode}/print_movement.pdf`;
                window.open(current_lot_url, '_blank');
            } else {
                setError('Error al actualizar dirección del predio. Verifica los datos.');
                setLoaderActive(false);
            }
        } catch (err) {
            setError('Error al guardar. Verifica los datos.');
            setLoaderActive(false);
        } finally {
            setLoaderActive(false);
        }
    };

    return (
        <>
            <div className="flex-auto py-6 pt-0">
                <h6 className="font-semibold uppercase bg-blue-500 text-white p-2 rounded-t-lg">
                    Información del predio actual
                </h6>
                <div className="flex flex-col lg:flex-row gap-4 min-h-[350px]">
                    <div
                        className="flex-grow border border-blue-gray-100 p-4 rounded-t-none rounded-b-lg w-full lg:w-1/2 overflow-x-hidden">
                        {lot && (
                            <CardBody className='p-0'>
                                <div className="w-full mb-4 bg-gray-100">
                                    {(lot.latitude && lot.longitude) && (
                                        <MapComponent
                                            parcel_code={lot.parcel_code}
                                            latitude={lot.latitude}
                                            longitude={lot.longitude}
                                        />
                                    )}
                                </div>
                                <div className='flex flex-col md:flex-row gap-4 w-full text-center'>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Dirección
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            {lot.road_name}{lot.ext_num ? " #" + lot.ext_num : ""}, {lot.neighborhood_name},
                                            C.P. {lot.postal_code}
                                        </Typography>
                                    </div>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Referencias
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            {lot.address_references === null ? '' : lot.address_references}
                                        </Typography>
                                    </div>
                                </div>
                                <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                                    REGISTRO DEL PREDIO
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            <div className='py-2'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                >
                                                    R.P.P.
                                                </Typography>
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Insc.
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.inscription}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Folio
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.folio}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Libro
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.book}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='py-2'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                >
                                                    Fecha efecto
                                                </Typography>
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Bim
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.effective_bimester}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Año
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.effective_year}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='py-2'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                >
                                                    Fecha exento
                                                </Typography>
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex w-full gap-1'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Bim. inicio
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.start_exempt_bimester}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Año inicio
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.start_exempt_year}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                    <div className='flex w-full gap-1'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Bim. fin
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.end_exempt_bimester}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Año fin
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.end_exempt_year}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                                    PROPIETARIO
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            <div className='py-2'>
                                                {lot.contributor_type === 'P' ? (
                                                    <div className='flex flex-row gap-4 w-full text-center'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Nombre
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.name}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Apellido paterno
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.parental_last_name}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Apellido Materno
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.maternal_last_name}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='flex flex-row gap-4 w-full text-center'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Razón social
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.name}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className='flex flex-row gap-4 mt-4 w-full text-center'>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Dirección
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.contributor_street}
                                                            {lot.contributor_ext_num ? " #" + lot.contributor_ext_num : ""}
                                                            {lot.contributor_neighborhood ? ', ' + lot.contributor_neighborhood : ''}
                                                            {lot.contributor_postal_code ? ', C.P. ' + lot.contributor_postal_code : ''}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Teléfono
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.phone ? lot.phone : 'N/A'}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            RFC
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.rfc ? lot.rfc : 'N/A'}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        )}
                    </div>
                </div>
            </div>
            <div className="flex-auto py-6 pt-0">
                <h6 className="font-semibold uppercase bg-blue-500 text-white p-2 rounded-t-lg">
                    Nueva clave catastral
                </h6>
                <div className="flex flex-col lg:flex-row gap-4">
                    <div
                        className="flex-grow border border-blue-gray-100 p-4 rounded-t-none rounded-b-lg w-full lg:w-1/2 overflow-x-hidden">
                        {step === 1 ? (
                            <>
                                <CardBody className='p-0'>
                                    <div className='flex flex-col md:flex-row gap-4 w-full text-center'>
                                        <div className='flex flex-col w-full'>
                                            <Typography
                                                variant="small"
                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                            >
                                                Clave catastral
                                            </Typography>
                                            <InputMask
                                                mask="519999-999-999"
                                                value={newParcelCode}
                                                onChange={(e) => setNewParcelCode(e.target.value)}
                                            >
                                                {(inputProps) => (
                                                    <input
                                                        {...inputProps}
                                                        type="text"
                                                        placeholder="51XXXX-XXX-XXX"
                                                        className="p-2 w-full border border-gray-300 rounded text-center"
                                                    />
                                                )}
                                            </InputMask>
                                        </div>
                                    </div>
                                </CardBody>
                                <Button
                                    className="w-full bg-green-500 mt-4 hover:bg-green-600 text-white rounded-md px-5 py-3 font-semibold"
                                    onClick={() => handleValidateParcelCode()}
                                    disabled={loaderActive}
                                >
                                    Validar clave catastral
                                </Button>
                                {
                                    error && <p style={{color: "red"}}>{error}</p>
                                }
                            </>
                        ) : (
                            <>
                                <CardBody className='p-0'>
                                    <div className='flex flex-col md:flex-row gap-4 w-full text-center'>
                                        <div className='flex flex-col w-full'>
                                            <Typography
                                                variant="small"
                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                            >
                                                Clave catastral
                                            </Typography>
                                            <Typography
                                                variant="paragraph"
                                                className="font-medium"
                                            >
                                                {newParcelCode}
                                            </Typography>
                                        </div>
                                    </div>
                                    <div className='flex flex-col md:flex-row gap-4 w-full text-center'>
                                        <div className='flex flex-col w-full'>
                                            <Typography
                                                variant="small"
                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                            >
                                                Tipo de predio
                                            </Typography>
                                            <Input value={parcelCodeData.location_type_id}
                                                   readOnly={true}
                                                   containerProps={{
                                                       className: '!min-w-0 max-w-1/3'
                                                   }}
                                                   disabled={true}
                                                   className='text-center'
                                            />
                                        </div>
                                        <div className='flex flex-col w-full'>
                                            <Typography
                                                variant="small"
                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                            >
                                                Sector
                                            </Typography>
                                            <Input value={parcelCodeData.sector_name}
                                                   readOnly={true}
                                                   containerProps={{
                                                       className: '!min-w-0 max-w-1/3'
                                                   }}
                                                   disabled={true}
                                                   className='text-center'
                                            />
                                        </div>
                                        <div className='flex flex-col w-full'>
                                            <Typography
                                                variant="small"
                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                            >
                                                Manzana
                                            </Typography>
                                            <Input value={parcelCodeData.block_name}
                                                   readOnly={true}
                                                   containerProps={{
                                                       className: '!min-w-0 max-w-1/3'
                                                   }}
                                                   disabled={true}
                                                   className='text-center'
                                            />
                                        </div>
                                        <div className='flex flex-col w-full'>
                                            <Typography
                                                variant="small"
                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                            >
                                                Lote
                                            </Typography>
                                            <Input value={parcelCodeData.batch}
                                                   readOnly={true}
                                                   containerProps={{
                                                       className: '!min-w-0 max-w-1/3'
                                                   }}
                                                   disabled={true}
                                                   className='text-center'
                                            />
                                        </div>
                                    </div>
                                    <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                    <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                                        NOTAS DE MOVIMIENTOS DEL PREDIO
                                    </h6>
                                    <div className="flex flex-wrap">
                                        <div className="w-full lg:w-12/12 px-0">
                                            <div className='flex flex-row gap-4'>
                                                <div className="relative w-full mb-3">
                                                    <Typography
                                                        variant="small"
                                                        className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                    >
                                                        Notas
                                                    </Typography>
                                                    <textarea
                                                        type="text"
                                                        className="border-blue-gray-100 px-3 py-3 placeholder-blue-gray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                        value={notes}
                                                        onChange={(e) => setNotes(e.target.value)}
                                                        rows="6"
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                                <Button
                                    className="w-full bg-green-500 mt-4 hover:bg-green-600 text-white rounded-md px-5 py-3 font-semibold"
                                    onClick={() => handleSubmit()}
                                    disabled={loaderActive}
                                >
                                    GUARDAR
                                </Button>
                                {
                                    error && <p style={{color: "red"}}>{error}</p>
                                }
                            </>
                        )}
                    </div>
                </div>
            </div>
            <Dialog open={openEndDialog} handler={setOpenEndDialog}>
                <DialogHeader>Guardado</DialogHeader>
                <DialogBody>
                    <Typography>
                        Se actualizo el predio
                    </Typography>
                </DialogBody>
                <DialogFooter>
                    <Button
                        className="bg-green-500 text-white"
                        onClick={() => handleReset()}
                        disabled={loaderActive}
                    >
                        Finalizar
                    </Button>
                </DialogFooter>
            </Dialog>
        </>
    )
};

export default CodeCorrection;
